export const toLowerCase = (list) => list.map((value) => value.toLowerCase());
